import React, { useState } from 'react';
import { Grid, Box, Typography, TextField, FormControlLabel, Switch } from "@mui/material";
import GenericDatePicker from './GenericDatePicker';
import GenericTimePicker from './GenericTimePicker';
import GenericDetailsTable from './Table/GenericDetailsTable';
import { Alert } from '@mui/material';

const GenericScanHeader = ({ scanDetails, infoRows, onScanDetailsChange }) => {
    
    const handleDateChange = (date) => {
        const currentTime = new Date(scanDetails.time);
        const combinedDateTime = new Date(
            date.year(),
            date.month(), // 0-indexed month
            date.date(),
            currentTime.getHours(),
            currentTime.getMinutes(),
            currentTime.getSeconds()
        ).toISOString();

        onScanDetailsChange('time', combinedDateTime);
    };

    const handleTimeChange = (timeValue) => {
        const currentDate = new Date(scanDetails.time);
        const combinedDateTime = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate(),
            timeValue.hour(),
            timeValue.minute(),
            timeValue.second()
        ).toISOString();

        onScanDetailsChange('time', combinedDateTime);
    };

    const nextConnPrettyPrint = (nextConnRaw) => {
        return  nextConnRaw ? 
        new Intl.DateTimeFormat('it-EU', { 
            day: '2-digit', 
            month: '2-digit', 
            year: 'numeric', 
            hour: '2-digit', 
            minute: '2-digit',
            hour12: false 
        }).format(new Date(nextConnRaw))
    : 'unknown' 
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={scanDetails.rightnow}
                            onChange={(e) => onScanDetailsChange('rightnow', e.target.checked)}
                            color="primary"
                        />
                    }
                    label="Execution as soon as possible"
                />
            </Grid>

            {scanDetails.rightnow && (
                    <Alert 
                        severity="info" 
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            borderRadius: 2, // Add rounded corners
                        }}
                    >
                        Task is expected to execute on ({nextConnPrettyPrint(scanDetails.gwDetails?.nextConnection)}).
                    </Alert>
            )}


            {!scanDetails.rightnow && (
                <Grid item xs={12} sm={12}>
                    <Box display="flex" flexDirection="row">
                        <GenericDatePicker initialDate={new Date(scanDetails.time)} onDateChange={handleDateChange} />
                        <GenericTimePicker initialTime={new Date(scanDetails.time)} onTimeChange={handleTimeChange} />
                        {new Date(scanDetails.time) < new Date() && (
                            <Alert 
                                severity="error" 
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    borderRadius: 2, // Add rounded corners
                                }}
                            >
                                Date must not be in the past!
                            </Alert>
                        )}

                        {scanDetails.gwDetails.nextConnection &&
                            new Date(scanDetails.time) < new Date(scanDetails.gwDetails.nextConnection) && (
                                <Alert 
                                    severity="info" 
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        borderRadius: 2, // Add rounded corners
                                    }}
                                >
                                    Selected time is before the next device reconnect ({nextConnPrettyPrint(scanDetails.gwDetails.nextConnection)}). 
                                    Please choose a later time or select Execution as soon as possible.
                                </Alert>
                            )
                        }
                    </Box>
                </Grid>
            )}

            {/* Scan Description */}
            <Grid item xs={12}>
                <TextField
                    label="Scan Description"
                    value={scanDetails.description}
                    multiline
                    fullWidth
                    variant="outlined"
                    onChange={(e) => onScanDetailsChange('description', e.target.value)}
                />
            </Grid>
            <Grid item xs={12}>
                <GenericDetailsTable
                    detailsValue={scanDetails}
                    detailsList={infoRows} />
            </Grid>
        </Grid>
    );
};

export default GenericScanHeader;
